import { useContext } from "react";
import { ViewContext } from "../providers";

const useView = () => {
  const viewContext = useContext(ViewContext);

  if (!viewContext) {
    throw new Error("useView must be used within an ViewProvider");
  }
  return viewContext;
};

export default useView;
